module.exports = __webpack_public_path__ + "img/products_big_can_berryblast.9517677c.png";